/**
 * incomingCallRequest.component.tsx
 * Secured Communication
 *
 * Created by: Dylan Knight
 * Copyright (c) 2022 Secured Communications. All rights reserved.
 *
**/

import * as React from "react";

import DialogContent from "@mui/material/DialogContent";
//import DialogTitle from "@mui/material/DialogTitle";
import DialogActions from "@mui/material/DialogActions";
import Fab from "@mui/material/Fab";
import Snackbar from "@mui/material/Snackbar";
import SnackbarContent from "@mui/material/SnackbarContent";
import Slide from "@mui/material/Slide";
import Typography from "@mui/material/Typography";

interface Props {
  open: boolean,
  callName: string,
  ignoreCall(): void,
  joinCall(): void
}
export function IncomingCallRequestComponent(props: Props): React.ReactElement<any, any> {

  const content = <>
    <Typography variant="h4">Incoming Call</Typography>
    <DialogContent>
      <p>From: {props.callName}</p>
    </DialogContent>
    <DialogActions>
      <Fab color="secondary" disableRipple disableTouchRipple
          size="small"
          onClick={props.ignoreCall}>
        <i className="fa-solid fa-xmark" />
      </Fab>
      <Fab color="primary"
          size="small"
          disableRipple disableTouchRipple
          onClick={props.joinCall}>
        <i className="fa-solid fa-phone" />
      </Fab>
    </DialogActions>
  </>;

  return props.open ? <Snackbar
      open={true}
      anchorOrigin={{vertical: "bottom", horizontal: "left"}}
      className="incoming-call-snackbar"
      onClose={props.ignoreCall}
      TransitionComponent={props => <Slide {...props}  direction="right" />}>
    <SnackbarContent message={content} />
  </Snackbar> : <></>;
}
